import React from 'react'
import CopyWriting from '../component/CopyWriting'
import Footer from '../component/Footer'
import SwiperTopic from '../component/SwiperTopic'

function Home() {
  return (
    <>

      <CopyWriting/>
      <SwiperTopic/>
      <Footer/>
 
      
    
    </>
  )
}

export default Home